var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cls,attrs:{"title":_vm.symbolName}},[(_vm.isShowMark)?_c('OrderMark',{attrs:{"is-main-order":_vm.isMAIN}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-tip"},[_vm._v("\n    "+_vm._s(_vm.symbolName)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }